import { ActionItemKeys } from '@uplift/api';
import { providerPatientRoute } from '@uplift/constants';
import { useTimezone } from '@uplift/contexts';
import { useAllActionItems, useL10n } from '@uplift/hooks';
import { Prescriptions } from '@uplift/icons';
import { CalendarDateService, formatTime } from '@uplift/services';
import { LinkDashboardActionItem } from '@uplift/ui-v2';
import { useCallback } from 'react';

export type NewPsychNoteProps = {
  appointmentId: string;
  patientId: string;
  patientName: string;
  nextAppointment: string;
  psychName: string;
};

export const NewPsychNote: React.VFC<NewPsychNoteProps> = ({
  appointmentId, patientId, patientName, nextAppointment, psychName
}) => {
  const l10n = useL10n();
  const timezone = useTimezone();
  const { dismiss } = useAllActionItems();

  const appt = CalendarDateService.date(nextAppointment).tz(timezone);
  const date = appt.format('MMM Do');
  const time = formatTime(appt);

  const handleDismiss = useCallback(() => {
    dismiss({
      key: ActionItemKeys.PROVIDER_NEW_PSYCH_NOTE,
      id: patientId
    });
  }, [ patientId, dismiss ]);

  return (
    <LinkDashboardActionItem
      icon={<Prescriptions />}
      color="info"
      title={l10n.dashboard.actionItems.newPsychNote.title(psychName, patientName)}
      details={l10n.dashboard.actionItems.newPsychNote.subtitle(date, time)}
      actionText={l10n.dashboard.actionItems.newPsychNote.actionText}
      link={providerPatientRoute.createLink(
        {
          patientId
        },
        {
          activityType: 'psychiatrySession',
          activityId: appointmentId
        }
      )}
      dismiss={{
        text: l10n.dashboard.actionItems.newPsychNote.dismissText,
        handleClick: handleDismiss
      }}
      onClick={handleDismiss}
    />
  );
};
